import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#0D1115] via-[#1A2733] to-[#1A2733]">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, #30D5C8 1px, transparent 1px),
                              linear-gradient(to bottom, #30D5C8 1px, transparent 1px)`,
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      {/* Glow effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#30D5C8] rounded-full blur-[150px] opacity-10" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8">
          <div className="inline-block">
            <div className="flex items-center space-x-2 bg-[#1A2733]/50 backdrop-blur-sm border border-[#30D5C8]/30 rounded-full px-4 py-2 mb-8">
              <div className="w-2 h-2 bg-[#30D5C8] rounded-full animate-pulse" />
              <span className="text-[#30D5C8] text-sm font-['Montserrat'] font-semibold">
                INDUSTRIAL AUTOMATION
              </span>
            </div>
          </div>

          <h1 className="font-['Montserrat'] font-extrabold text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-[#F5F7F8] leading-tight">
            PROJECT FLOW™
            <br />
            <span className="text-[#30D5C8]">AUTOMATIONS</span>
          </h1>

          <p className="font-['Montserrat'] text-2xl sm:text-3xl md:text-4xl text-[#CBD3D9] font-semibold max-w-4xl mx-auto">
            Built for Heavy Industry.
          </p>

          <div className="max-w-3xl mx-auto space-y-4">
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans']">
              Automation that actually works in the field.
            </p>
            <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans']">
              Real-time insights. Zero-bloat workflows. Faster decisions.
            </p>
            <p className="text-[#506273] text-base sm:text-lg font-['Open_Sans'] font-semibold mt-6">
              Supporting EPC, Turnarounds, Capital Projects, and Maintenance.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#30D5C8] text-[#0D1115] hover:bg-[#30D5C8]/90 font-['Montserrat'] font-bold text-lg px-8 py-6 rounded-lg group"
            >
              Explore Products
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-2 border-[#30D5C8] text-[#30D5C8] hover:bg-[#30D5C8]/10 font-['Montserrat'] font-bold text-lg px-8 py-6 rounded-lg"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0D1115] to-transparent" />
    </section>
  );
};